import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { __, setTableParams } from '../../../../core/utils';
import {
  setCursorTooltip,
  updateTool,
} from '../../../../redux/actions/canvas_editor';
import Button from '../Toolbar/Button';
import SpecificationIcon from '../../images/Icon20_Specification.svg';
import { listPinnedPlanVersionSpecifications } from '../../../../redux/actions/table/working_set_plans';
import { listPinnedPlanRevisionSpecifications } from '../../../../redux/actions/table/current_set_plans';

const Specification = ({
  canvas_editor: { viewer, fabricOverlay },
  source,
  isActive,
  table,
  user_id,
  match,
}) => {
  const table_name =
    match.path == '/plans/revisions/:plan_revision'
      ? 'current_set_plans'
      : 'working_set_plans';

  table = table[table_name];

  useEffect(() => {
    if (!isActive || !fabricOverlay) return;

    const canvas = fabricOverlay.fabricCanvas();

    canvas.defaultCursor = 'crosshair';
    // canvas.defaultCursor = `url(${TaskCursorIcon}) 10 22, auto`;
    // canvas.hoverCursor = 'crosshair';

    setCursorTooltip(__('canvas.tooltip.specification'));

    canvas.getObjects().forEach((obj) => {
      obj.selectable = false;
      obj.evented = false;
    });

    function onMouseDown(options) {
      if (options.target || !isActive) return;

      const rawPointer = canvas.getPointer(options.e);

      const x = rawPointer.x;
      const y = rawPointer.y;

      viewer.setMouseNavEnabled(true);

      if (x < 0 || x > source.width || y < 0 || y > source.height) {
        return;
      }

      setTableParams(table_name, {
        x,
        y,
        attach_specification_wizard: true,
        stage_id: source.stage_id,
      });
    }

    const onPointerDown = (e) => {
      viewer.setMouseNavEnabled(false);
    };

    canvas.upperCanvasEl.addEventListener('pointerdown', onPointerDown);

    canvas.on('mouse:down', onMouseDown);

    return () => {
      canvas.off('mouse:down', onMouseDown);
      canvas.upperCanvasEl.removeEventListener('pointerdown', onPointerDown);
    };
  }, [fabricOverlay, isActive]);

  const createSpecification = (x, y, specificationCodeID, uid) => {
    const canvas = fabricOverlay.fabricCanvas();

    const background = new fabric.Path(
      'M64 32 A32 32 0 1 1 0 32 A32 32 0 1 1 64 32 Z',
      {
        fill: 'rgba(255, 0, 0, 0.33)',
        stroke: null,
        strokeWidth: 0,
        selectable: false,
        evented: false,
      }
    );

    const foreground = new fabric.Path(
      'M13.6658 21.0867 L32.1235 31.8511 ' +
        'M32.1254 54.1072 L32.1254 31.8536 ' +
        'M50.5853 21.0867 L32.1274 31.8511 ' +
        'M13.051 40.1923 L13.051 23.5148 ' +
        'C13.051 21.7854 13.9284 20.1832 15.3526 19.2803 ' +
        'L29.6585 10.3153 ' +
        'C31.1781 9.3616 33.073 9.3616 34.5923 10.3153 ' +
        'L48.8982 19.2803 ' +
        'C50.3226 20.1832 51.2 21.7854 51.2 23.5148 ' +
        'L51.2 40.1923 ' +
        'C51.2 41.9216 50.3226 43.5242 48.8982 44.4269 ' +
        'L34.5923 53.392 ' +
        'C33.073 54.3456 31.1781 54.3456 29.6585 53.392 ' +
        'L15.3526 44.4269 ' +
        'C13.9284 43.5242 13.051 41.9216 13.051 40.1923 Z',
      {
        fill: 'transparent',
        stroke: '#000000',
        strokeWidth: 3.84,
        strokeLineCap: 'round',
        strokeLineJoin: 'round',
        selectable: false,
        evented: false,
      }
    );

    const obj = new fabric.Group([background, foreground], {
      originX: 'left',
      originY: 'top',
    });

    obj.set({
      left: x,
      top: y,
      objectType: 'specification',
      originalLeft: x,
      originalTop: y,
      specificationCodeID: specificationCodeID,
      userID: uid,
      lockScalingX: true,
      lockScalingY: true,
      hasControls: false,
      hasBorders: false,
    });
    obj.setCoords();

    if (table_name === 'current_set_plans') {
      listPinnedPlanRevisionSpecifications(match.params.plan_revision);
    } else listPinnedPlanVersionSpecifications(match.params.plan_version);

    canvas.add(obj);

    viewer.setMouseNavEnabled(true);
  };

  useEffect(() => {
    if (table.specification_code_id) {
      createSpecification(
        table.x,
        table.y,
        table.specification_code_id,
        user_id
      );

      setTableParams(table_name, {
        specification_code_id: undefined,
        x: undefined,
        y: undefined,
      });
    }
  }, [table?.specification_code_id]);

  const toggleTool = () => {
    updateTool({ tool: 'specification' });
  };

  return (
    <Button
      id='plan'
      label={__('canvas.toolbar.specification')}
      icon={SpecificationIcon}
      active={isActive}
      onClick={toggleTool}
      extraClass={['withSpacer']}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    canvas_editor: state.canvas_editor,
    table: state.table,
    user_id: state.auth.id,
  };
};

export default withRouter(connect(mapStateToProps, null)(Specification));
